<template>
    <section>

      <el-col :span="24">

        <section>

          <h5>General Remarks</h5>
          <div v-if="isTelco() && this.isActive(this.actionData)">
            <html-input v-model="actionData.remarks" clsStyle="width: 52.8vw; overflow: auto;" :disabled="disabled" />
          </div>
          <div class="html-remarks" v-else>
            <p v-if="actionData.remarks" v-safe-html="actionData.remarks"></p>
            <p v-else class="text-muted">No client remarks</p>
          </div>

          <hr v-if="step.remarks" />

        </section>


        <el-alert
        v-if="this.isActive(this.actionData)"
        type="info"
        title="Progress Remarks"
        show-icon />

        <!-- XOL-371: this save is canWriteStep()-gated at the API; disable instead of showing a misleading-editable input -->
        <html-input v-model="step.remarks" :disabled="!canWriteStep() || !this.isActive(this.actionData)" />

    </el-col>

  </el-col>

  </section>
</template>



<script>

import SiteMixins from '@/mixins/SiteMixins'

import RequestMixins from '@/mixins/RequestMixins'

import FileDownload from '@/components/atoms/files/FileDownload'
import FileUpload from '@/components/atoms/files/FileUpload'

export default {

  mixins: [SiteMixins, RequestMixins],

  components: {
    FileDownload,
    FileUpload
  },


  props: {

    rowData: {
      type: Object,
      required: true
    },

    rowIndex: {
      type: Number,
      default: null
    },

    stepData: {
      type: Object,
      default: null
    },

    readOnly: {
      type: Boolean,
      default: true
    }

  },


  methods: {

    setStep (data) {
      if (data) {
        this.step = data
      }
    }

  },


  computed: {

    disabled () {
      return !this.canWriteStep() || this.isViewOnly() || this.readOnly
    }

  },


  data () {

    return {
      actionData: this.rowData,
      step: this.stepData
    }

  },  // data


  created () {

    if (this.canWriteStep() && !this.readOnly && this.step) {
      this.findStep(this.stepData.id, this.setStep)
    }

  },


  beforeDestroy () {

    this.$emit('updated', this.step)

    if (this.canWriteStep() && !this.readOnly && this.step) {
      this.saveStep(this.step)
    }

  }

}

</script>
